import * as fieldset from './fieldset';

export default {
  title: 'Crea Coupon Membership',
  elements: [
    {
      type: 'createForm',
      config: {
        actions: {
          save: {
            endpoint: 'membership-coupons',
            method: 'POST'
          }
        },
        fieldsets: [fieldset.main]
      }
    }
  ]
};
